/**
 * @file automatically generated from MApp.Endpoints.Models.PreviewType
 */

export enum PreviewType {
    None = 0,
    Line = 1,
    Area = 2,
    GeometryCollection = 3,
    Text = 5,
    Point = 6,
    Dimensioning = 7,
    TrafficNetwork = 8,
    HeatMap = 9,
    ClusterPoint = 10
}
